<template>
  <div class="flex space-x-2.5">
    <v-text-field label="Buy Quantity" type="number" :value="buyQty" outlined dense hide-details />
    <v-text-field label="Get Quantity" type="number" :value="getQty" outlined dense hide-details
                  @input="getQuantityChange" />
  </div>
</template>

<script>
export default {
  name: 'B1gx',
  props: {
    buyQty: {
      type: Number,
      default: 1,
    },
    getQty: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    /**
     * Description
     * @param {InputEvent} e
     */
    getQuantityChange(val) {
      this.$emit('update:getQty', val || 0)
    },
  },
}
</script>